import { getApiCall } from "../../utils/request";
import { returnErrors } from "../errorAction";
import { GET_REWARDS_LIST, GET_NEXT_REWARDS_LIST, GET_REWARDS_SEARCH,RESET_SEARCH_LOADING } from '../../actionType/type';

export const getRewardsList = (page, from, to) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/users/redeem?page=${page}&from=${from}&to=${to}`);
        dispatch({ type: GET_REWARDS_LIST, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getNextRewardsList = (page, from, to) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/users/redeem?page=${page}&from=${from}&to=${to}`);
        dispatch({ type: GET_NEXT_REWARDS_LIST, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}


export const getRewardSearch = (query, page) => async (dispatch) => {
    try {
        const response = await getApiCall(`admin/users/redeem/search?page=${page}&query=${query}`);
        dispatch({ type: GET_REWARDS_SEARCH, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const resetSearchLoading = () => async (dispatch) => {

    dispatch({ type: RESET_SEARCH_LOADING});

}



